export function processingSeparator(content: TContent): TContent | undefined {
  if (content.children[0]) {
    return content.children[0];
  }
}
